import { render, staticRenderFns } from "./AVehicleTco.vue?vue&type=template&id=5b8172ca&scoped=true"
import script from "./AVehicleTco.vue?vue&type=script&lang=js"
export * from "./AVehicleTco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8172ca",
  null
  
)

export default component.exports